import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../context/userContext/userContext';
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Paper,
  CircularProgress,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import CancelSubConfirmModal from './CancelSubConfirmModal';
import SubscribeBanner from '../../components/SubscribeBanner/SubscribeBanner';
import Seo from '../../components/Seo';


export default function ManageSubscription() {
  const [subscription, setSubscription] = useState(null);
  const [height, setHeight] = useState(window.innerHeight)
  const [loading, setLoading] = useState(true);
  const [subscriptionsVisible, setSubscriptionsVisible] = useState(false)
  const { userEmail } = useContext(UserContext);
  const [cancelConfirmModalOpen, setCancelConfirmModalOpen] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchSubscription = async () => {
      setLoading(true);
      await loadSubscriptionInfo();
      setLoading(false);
    };
    fetchSubscription();
  }, [userEmail]);

  const navToMyGear = () => {
   // setOpen(false)
    navigate('/my-gear');
  };

  const closeModal = async () => {
    setCancelConfirmModalOpen(false);
    loadSubscriptionInfo();
  }
  const openModal = async () => {
    setCancelConfirmModalOpen(true)
  }

const navToSubscribePage = () => {
  window.location.href = `https://buy.stripe.com/6oE3gfaAxdanaticMM?prefilled_email=${userEmail}`
}

  const handleCancel = async () => 
    {

        if (!subscription[0]) return;
        try {


          const cancellation = await axios.post('/api/cancel-subscription', {
            subscriptionId: subscription[0].stripeID,
            subscriptionObjNumber: subscription[0]._id,
          });
          //alert('Subscription will be canceled at the end of the period.');
          setSubscription([{ ...subscription[0], cancelAtPeriodEnd: true }]);
          navigate('/manage-subscriptions');
          closeModal();
        } catch {
          console.log('Error processing cancel request');
        }
  };

  const loadSubscriptionInfo = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const { data } = await axios.post('/api/manage-subscription', { token });
        if (data.error) {
          toast.error(data.error);
        } else {

        let activeSubCount = 0;
        for(var i = 0; i < data.length; i++)
        {

            const cancelAt = data[i].cancelAt ? new Date(data[i].cancelAt) : null;
            
            if(cancelAt)
            {
                const isCancelled = cancelAt && cancelAt > now;
                const isExpired = cancelAt && cancelAt <= now;
                if(!isExpired)
                {
                    activeSubCount++;
                }

            }
            if(!cancelAt)
            {
                activeSubCount++;
            }


            //console.log(data[i].cancelAt)
        }

        if(activeSubCount > 0)
        {
            //console.log("set subscription visible true")
            setSubscriptionsVisible(true)
        }
        else{
            setSubscriptionsVisible(false)
        }
          setSubscription(data);
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const style = {
    color1: 'rgb(39, 55, 77)',
    color2: 'rgb(82, 109, 130)',
    color3: 'rgb(157, 178, 191)',
    color4: 'rgb(221, 230, 237)',
  };

  const now = new Date();

  return (
    <>

<Seo
  title="Manage Subscription | Parish Audio"
  description="Manage your Parish Audio subscription, billing, and renewal settings."
  canonical="https://parishaudio.com/manage-subscriptions"
  robots="noindex,follow"
/>
    <div style={{minHeight: height - 130}}>
    <Box sx={{ maxWidth: 600, minHeight:'400px', mx: 'auto', p: 4, backgroundColor: 'black', color: style.color4 }}>
      <h1 style={{marginBottom:'25px'}}>
        Subscriptions
        </h1>
        {!subscriptionsVisible && (<>
        <p style={{marginBottom:'35px'}}>
            You don’t currently have an active subscription.
        </p>
        <SubscribeBanner />
        </>)}


      {loading ? (
        <Box textAlign="center" mt={4}>
          <CircularProgress color="inherit" />
        </Box>
      ) : subscription ? (
        subscription.map((sub, index) => {
          const cancelAt = sub.cancelAt ? new Date(sub.cancelAt) : null;
          const isCancelled = cancelAt && cancelAt > now;
          const isExpired = cancelAt && cancelAt <= now;
          if (isExpired) return null;

          const formatDate = (date) => new Date(date).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });

          return (
            <Paper
              key={index}
              elevation={6}
              sx={{ backgroundColor: style.color1, p: 3, mt: 3, borderRadius: 2, color: style.color4 }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SubscriptionsIcon sx={{fontSize:'1.2em', color: style.color3, mr: 1 }} />
                  <h2 style={{fontSize:'1.1em'}}>
                    Monthly Subscription
                  </h2>
                </Box>
                <Typography variant="body1" sx={{ml:1, fontSize:'1em', fontWeight: 'bold' }}>
                  $9.95 / month
                </Typography>
              </Box>
              <Divider sx={{ mb: 2, borderColor: style.color2 }} />

              {!isCancelled && (
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Renews on: {formatDate(sub.currentPeriodEnd)}
                </Typography>
              )}

              {isCancelled ? (
                <Typography variant="body1" color="warning.main" sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                  <CancelIcon sx={{ mr: 1 }} />
                  This subscription is canceled. You will be able to use your plugins until: {formatDate(cancelAt)}
                </Typography>
              ) : (<div style={{textAlign:'center', margin:'auto', marginTop:'50px', padding:'5px'}}>

                <Button
                  variant="contained"
                  onClick={navToMyGear}
                  sx={{margin:'15px', width:'40%', minWidth:'150px', backgroundColor: style.color2, color: style.color4, '&:hover': { backgroundColor: style.color3 } }}
                >
                  Download Plugins
                </Button>
                <Button
                variant="contained"
                onClick={openModal}
                sx={{ margin:'15px', width:'40%', minWidth:'150px', backgroundColor: style.color2, color: style.color4, '&:hover': { backgroundColor: style.color3 } }}
              >
                Cancel Subscription
              </Button>
              </div>
              )}
            </Paper>
          );
        })
      ) : (
        <>
        </>

       
      )}

    </Box>
    </div>
    <div id='modal-root'>
                    {/* <CancelSubConfirmModal isOpen={cancelConfirmModalOpen} close={closeModal} subscription={subscription}>

                    </CancelSubConfirmModal> */}

                    <Dialog open={cancelConfirmModalOpen} onClose={closeModal} fullWidth maxWidth="md">

              <>
              <DialogTitle size="small" sx={{ display: 'flex', pt:0, pb:0,justifyContent: 'space-between', alignItems: 'center', backgroundColor: style.color2, color: style.color4 }}>
               <span style={{fontSize:'0.9em', marginTop:'0px', marginBottom:'0px'}}>Cancel Subscription</span>
              <IconButton onClick={closeModal} sx={{ color: style.color4 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            
            <DialogContent dividers sx={{ backgroundColor: style.color1, color: style.color4 }}>
              <div>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt:0 }}>
              <Typography sx={{fontSize:"1.2em", mr:1, ml:.5}}>If you choose to unsubscribe, your plugins will remain available until the end of the current period.</Typography>

                </Box>
             
              </div>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: style.color1 }}>
              <Button size="small" sx={{fontSize:".8em", mt: 1, mb:2, borderColor:style.color3, minWidth:'100px', maxWidth:'120px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color2, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} onClick={closeModal} variant="contained">
                <strong>Go Back</strong>
              </Button>
              <Button size="small" sx={{fontSize:'.8em', mt: 1, mb:2, borderColor:style.color3, minWidth:'100px', maxWidth:'120px', borderWidth:'1px', borderStyle:'solid',  backgroundColor:style.color2, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' }}} onClick={handleCancel} variant="contained">
                <strong>Unsubscribe</strong>
              </Button>
            </DialogActions>

              </>

            
          </Dialog>
    </div>

    </>
  );
}
